<template>
  <section class="content" style="background-color: #EBECF1; height: 100%">
    <div id="page-wrapper">
      <section id="header">
        <div class="container">
          <h1 id="logo"><a class="titulo">Mantenimiento de Usuarios</a></h1>
          <p>Gestiona las operaciones y roles de los usuarios de la institución.</p>
          <nav id="nav">            
            <!----   
            <ul>
              <li><a class="icon fa-tasks"><span>Aplicaciones</span></a></li>
              <li><a class="icon fa-pie-chart"><span>Operaciones</span></a></li>
              <li><a class="icon fa-cog"><span>Roles</span></a></li>
              <li><a class="icon fa-table"><span>Áreas</span></a></li>
              <li><a class="icon fa-book"><span>Personal</span></a></li>
            </ul>            
          -->                         
            <ul>
              <router-link v-for="(route, index) in userRol" :key="route.path" :to="route.enlaceWeb" tag="li"
                class="pageLink" v-show="index !== 0">
                <a class="icon" :class="route.icono">
                  <span>{{ route.descripcion }}</span>
                </a>
              </router-link>
            </ul>

          </nav>
        </div>
      </section>
      <section id="features">
        <div class="row aln-center p-l-40 p-r-40">
          <div class="col-4 col-6-medium col-12-small">
            <section>
              <a href="#" class="image featured"><img src="static/img/inicio.jpg" alt="" /></a>
              <p>Con nuestro nuevo sistema brinda mantenimiento a los usuarios del <a href="https://www.tc.gob.pe"
                  target="_blank">TRIBUNAL CONSTITUCIONAL</a>.</p>
            </section>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>

export default {
  //name: 'HelloWorld',
  name: 'Inicio',
  data() {
    return {
      ip: '',
      response: ''
    }
  },
  //// Menú dinámico horizontal
  computed: {
    userRol() {
      // Obtén el userRol desde el estado del Vuex
      //const userRol = this.$store.state.userRol || [];
      const userRol = JSON.parse(localStorage.getItem('userRolData')) || [];
      return userRol;
    },
  },
  mounted() {    
    //console.log('-----AccessToken', localStorage.getItem('AccessToken'))
    //console.log('--- tokenExpiration', localStorage.getItem('tokenExpiration'))
    //console.log('--TokenCurrentTime', localStorage.getItem('TokenCurrentTime'))
    //console.log('--TokenExpirationTime', localStorage.getItem('TokenExpirationTime'))
    //console.log('---userRol', JSON.parse(localStorage.getItem('userRolData')))
    //console.log(JSON.parse(localStorage.getItem('userData')).dni)
    //console.log(JSON.parse(localStorage.getItem('userData')).nombres)
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// Inicio.vue?6b2197fc